export default __webpack_public_path__ + "static/media/modalMax.9420c346.svg";